import React from 'react';
import { Grid, Button, CircularProgress, useTheme } from '@mui/material';
import Alert from '@mui/material/Alert';

import MultiSelectAutocomplete from '@shared/components/MultiSelectAutocomplete';
import { useFavoriteForm } from '@HotelSearchHooks/useFavoriteForm';

import FavMessageSelect from './FavMessageSelect';
import StyledTextField from '@shared/components/StyledTextField';
import SectionGrid from '@shared/components/SectionGrid';

import { sxStyled } from './styles';

const FavoritesForm = ({
  hotel,
  user,
  favMessage,
  handleFavMessage,
  fav_messages,
  sites,
  isAdmin,
  hotReferenceCities,
  setIsLoading,
  setIsShowAlert,
  setAlertOptions,
  handleClose,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const {
    formik,
    sitesToShow,
    handleSitesChange,
    errorMessage,
    isSubmitting,
  } = useFavoriteForm({
    hotel,
    user,
    favMessage,
    hotReferenceCities,
    sites,
    isAdmin,
    setIsLoading,
    setIsShowAlert,
    setAlertOptions,
  });

  return (
    <SectionGrid mdVal={12}>
      {errorMessage && (
        <Grid item xs={12}>
          <Alert severity="error" sx={sxStyle.submitMargin}>
            {errorMessage}
          </Alert>
        </Grid>
      )}

      {isSubmitting && (
        <Grid item xs={12} container justifyContent="center">
          <CircularProgress color="primary" />
        </Grid>
      )}

      <form onSubmit={formik.handleSubmit} noValidate style={{ width: '100%' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledTextField
              name="priority"
              label="Prioridad"
              type="number"
              value={formik.values.priority}
              onChange={formik.handleChange}
              error={formik.touched.priority && Boolean(formik.errors.priority)}
              helperText={formik.touched.priority && formik.errors.priority}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <StyledTextField
              name="main_image"
              label="Imagen principal (opcional)"
              value={formik.values.main_image}
              onChange={formik.handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <FavMessageSelect
              favMessage={favMessage}
              handleFavMessage={handleFavMessage}
              fav_messages={fav_messages}
            />
          </Grid>

          {isAdmin && (
            <Grid item xs={12}>
              <MultiSelectAutocomplete
                items={sites}
                value={sitesToShow}
                label="Sitios"
                name="available_sites"
                formik={formik}
                id="favorite-sites"
                handleSelect={handleSitesChange}
                toSelect="name"
                toFindAll="value"
              />
            </Grid>
          )}

          <Grid
            item
            xs={12}
            container
            justifyContent="flex-end"
            spacing={1}
            sx={sxStyle.submitContainer}
          >
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={handleClose}
                style={{ backgroundColor: '#7E7E7E' }}
              >
                Cerrar
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                sx={sxStyle.submitButton}
                disabled={isSubmitting}
              >
                Agregar a favoritos
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </SectionGrid>
  );
};

export default FavoritesForm;
